import type React from "react";
import { useSearchParams } from "react-router-dom";

const SearchResultPage: React.FC = () => {
	const [searchParams] = useSearchParams();
	const query = searchParams.get("q") || "";

	return (
		<div className="space-y-6">
			<h1 className="text-3xl font-bold">検索結果: {query}</h1>
			<div className="bg-white p-6 rounded-lg shadow">
				{/* 検索結果を表示するコンポーネントをここに配置 */}
			</div>
		</div>
	);
};

export default SearchResultPage;
